import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-moview-supplier',
  templateUrl: './moview-supplier.component.html',
  styleUrls: ['./moview-supplier.component.scss']
})
export class MoviewSupplierComponent implements OnInit {

  settingslocation: { idField:string;textField:string; singleSelection: boolean; text: string; selectAllText: string; unSelectAllText: string; enableSearchFilter: boolean; classes: string; badgeShowLimit: number; };
  settingssuppliercode: {idField:string; textField:string; singleSelection: boolean; text: string; selectAllText: string; unSelectAllText: string; enableSearchFilter: boolean; classes: string; badgeShowLimit: number; };
  options: { title: { display: boolean; text: string; fontSize: number; }; legend: { position: string; }; };
  settingsmonthCode: {idField:string,textField:string; singleSelection: boolean; text: string; enableSearchFilter: boolean; classes: string; badgeShowLimit: number; };
  monthCodeList: { "id": number; "itemName": string; }[];
  locationCodeList: { "id": number; "itemName": string; }[];
  supplierCodeList: { "id": number; "itemName": string; }[];
  suppliercodes: any;
  monthnames: any;
  locationnames: any;
  data: { labels: string[]; datasets: { label: string; backgroundColor: string; borderColor: string; data: number[]; }[]; };
  constructor(private translate: TranslateService) { }
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true,
    scaleShowValues: true,
    scaleValuePaddingX: 10,
    scaleValuePaddingY: 10,
    animation: {
      onComplete: function () {
        var chartInstance = this.chart,
          ctx = chartInstance.ctx;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
        this.data.datasets.forEach(function (dataset, i) {
          var meta = chartInstance.controller.getDatasetMeta(i);
          meta.data.forEach(function (bar, index) {
            var data = dataset.data[index];
            ctx.fillText(data, bar._model.x, bar._model.y - 6);
          });
        });
      }
    }
  };
  ngOnInit() {
    this.settingssuppliercode = {
      idField: 'id',
      textField:'itemName',
      singleSelection: false,
      text: "Select Supplier Code",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 4,
    };
    this.settingslocation = {
      idField:'id',
      textField:'itemName',
      singleSelection: false,
      text: "Select Supplier Code",
      selectAllText: this.translate.instant('Select All'),
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 4,
    }
    this.settingsmonthCode = {
      idField:'id',
      textField:'itemName',
      singleSelection: true,
      text: "Select Supplier Code",
      enableSearchFilter: true,
      classes: "custom-class",
      badgeShowLimit: 4,
    };
    this.supplierCodeList = [
      { "id": 1, "itemName": "S01" },
      { "id": 2, "itemName": "S02" },
      { "id": 3, "itemName": "D01" },
      { "id": 4, "itemName": "D02" },
      { "id": 5, "itemName": "D03" },
      { "id": 6, "itemName": "E01" },
      { "id": 7, "itemName": "E02" },
      { "id": 8, "itemName": "Y13" },
      { "id": 9, "itemName": "Y10" },
      { "id": 10, "itemName": "RY01" }
    ];
    this.locationCodeList = [
      { "id": 1, "itemName": "CC Yokohama" },
      { "id": 2, "itemName": "K1" },
      { "id": 3, "itemName": "K2" },
      { "id": 4, "itemName": "Atsugi" },
      { "id": 5, "itemName": "HO" },
      { "id": 6, "itemName": "Nakatsu" },
      { "id": 7, "itemName": "MFBM" },
      { "id": 8, "itemName": "Nakatsu" },
      { "id": 9, "itemName": "Resale_Direct" },
      { "id": 10, "itemName": "Resale_K2" },
      { "id": 11, "itemName": "TAA_HQ" }
    ];
    this.monthCodeList = [
      { "id": 1, "itemName": "January" },
      { "id": 2, "itemName": "Febuary" },
      { "id": 3, "itemName": "March" },
      { "id": 4, "itemName": "April" },
      { "id": 5, "itemName": "May" },
      { "id": 6, "itemName": "June" },
      { "id": 7, "itemName": "July" },
      { "id": 8, "itemName": "August" },
      { "id": 9, "itemName": "September" },
      { "id": 10, "itemName": "October" },
      { "id": 11, "itemName": "November" },
      { "id": 12, "itemName": "December" }
    ];
    this.data = {
      labels: ['Day1', 'Day2', 'Day3', 'Day4', 'Day5', 'Day6', 'Day6', 'Day7', 'Day8', 'Day9', 'Day10', 'Day11', 'Day12', 'Day13', 'Day14', 'Day15', 'Day16', 'Day17', 'Day18', 'Day19', 'Day20', 'Day21', 'Day22', 'Day23', 'Day24', 'Day25', 'Day26', 'Day27', 'Day28', 'Day29', 'Day30'],
      datasets: [
        {
          label: 'CC Yokohama',
          backgroundColor: '#13135d',
          borderColor: '#13135d',
          data: [65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55, 40, 80, 81, 56]
        },
        {
          label: 'K1',
          backgroundColor: '#9CCC65',
          borderColor: '#7CB342',
          data: [28, 48, 40, 19, 86, 27, 90, 65, 59, 80, 81, 56, 55, 40, 28, 48, 40, 19, 86, 27, 90, 28, 48, 40, 19, 86, 27, 90, 81, 56, 55]
        },
        {
          label: 'K2',
          backgroundColor: '#DF0101',
          borderColor: '#DF0101',
          data: [28, 48, 40, 19, 86, 27, 90, 65, 59, 80, 81, 56, 55, 40, 28, 48, 40, 19, 86, 27, 90, 28, 48, 40, 19, 86, 27, 90, 81, 56, 55]
        },

        //       {
        //         label: 'Atsugi',
        //         backgroundColor: '#DF7401',
        //         borderColor: '#DF7401',
        //         data: [65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55, 40,65, 59, 80, 81, 56, 55, 40, 81, 56, 55]
        //     },
        //     {
        //         label: 'HO',
        //         backgroundColor: '#1C1C1C',
        //         borderColor: '#1C1C1C',
        //         data: [28, 48, 40, 19, 86, 27, 90, 65, 59, 80, 81, 56, 55, 40, 28, 48, 40, 19, 86, 27, 90,28, 48, 40, 19, 86, 27, 90, 81, 56, 55]
        //     },
        //     {
        //       label: 'MFBM',
        //       backgroundColor: '#0A0A2A',
        //       borderColor: '#0A0A2A',
        //       data: [65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55, 40,65, 59, 80, 81, 56, 55, 40, 81, 56, 55]
        //   },
        //   {
        //       label: ' Nakatsu',
        //       backgroundColor: '#298A08',
        //       borderColor: '#298A08',
        //       data: [28, 48, 40, 19, 86, 27, 90, 65, 59, 80, 81, 56, 55, 40, 28, 48, 40, 19, 86, 27, 90,28, 48, 40, 19, 86, 27, 90, 81, 56, 55, 40]
        //   },
        //   {
        //     label: ' Resale_Direct',
        //     backgroundColor: '#04B4AE',
        //     borderColor: '#04B4AE',
        //     data: [65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55, 40,65, 59, 80, 81, 56, 55, 40, 81, 56, 55, 40]
        // },
        // {
        //     label: 'Resale_K2',
        //     backgroundColor: '#B45F04',
        //     borderColor: '#B45F04',
        //     data: [28, 48, 40, 19, 86, 27, 90, 65, 59, 80, 81, 56, 55, 40, 28, 48, 40, 19, 86, 27, 90,28, 48, 40, 19, 86, 27, 90, 81, 56, 55, 40]
        // }
        // ,
        //   {
        //     label: 'TAA_HQ',
        //     backgroundColor: '#08088A',
        //     borderColor: '#08088A',
        //     data: [65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55, 40, 65, 59, 80, 81, 56, 55, 40,65, 59, 80, 81, 56, 55, 40, 81, 56, 55, 40]
        // },

      ],

    }
    this.options = {
      title: {
        display: true,
        text: 'My Title',
        fontSize: 16
      },
      legend: {
        position: 'top'
      }
    };
  }
  updatemonthlyView() {

  }
  onSingleSelectSupplierCode(any) { };
  onDeSelectSupplierCode(any) { };
  onSelectAllSupplierCode(any) { };
  DeSelectAllSupplierCode(any) { };
  onSingleSelectmonth(any) { };
  onDeSelectmonth(any) { };
  onSingleSelectLocation(any) { };
  DeSelectAllLocation(any) { };
  onDeSelectLocation(any) { };
  onSelectAllLocation(any) { };


}
